import {
  Section,
  Divider,
  H2,
  H3,
  P,
  CheckInput,
  TealSubSection,
  DataField,
} from "./common-components";

export const AMRGoals = ({medications, formType}) => {
  return (
    <Section formType={formType}>
      <H2>Goals for Therapy</H2>
      <div className="space-y-1">
        <ul className="list-disc space-y-[0.0416667in] text-[0.125in] ml-[0.25in]">
          <li>Manage medications</li>
          <li>Manage side effects</li>
          <li>Manage chronic conditions</li>
          <li>Improve qualities of life</li>
        </ul>

        <TealSubSection isBlue={false}>
          <DataField
            label={"Personal Goals (Optional)"}
            value={medications?.personalGoals}
          />
        </TealSubSection>
        {medications?.howToAchieveGoals && (
          <TealSubSection isBlue={false}>
            <DataField
              label={"How to achieve the goals? (Optional)"}
              value={medications?.howToAchieveGoals}
            />
          </TealSubSection>
        )}
      </div>
    </Section>
  );
};
